import {useEffect, useState} from 'react';
import Image from "next/image";
import brand1 from "../../public/images/brand/brand-01.png";
import brand2 from "../../public/images/brand/brand-02.png";
import brand3 from "../../public/images/brand/brand-03.png";
import brand4 from "../../public/images/brand/brand-04.png";
import brand5 from "../../public/images/brand/brand-05.png";
import brand6 from "../../public/images/brand/brand-06.png";
import brand7 from "../../public/images/brand/brand-07.png";
import brand8 from "../../public/images/brand/brand-08.png";

const Brands = ({messages}) => {
  const [Brands, setBrands] = useState([]);
  useEffect(() => {
    async function fetchBrands() {
      const response = await fetch("/api/brands");
      const data = await response.json();
      setBrands(data);
    }

    fetchBrands();
  }, [])
  

  return (
    <>
      <div className="rainbow-brand-area rainbow-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="section-title text-center sal-animate"
                data-sal="slide-up"
                data-sal-duration="700"
                data-sal-delay="100"
              >
                <h4 className="subtitle ">
                  <span className="theme-gradient">{messages["brand-title"]}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 mt--10">
              <ul className="brand-list brand-style-2">
                {Brands && Brands.map((data, index) => (
                  <li>
                  <a href="#">
                    <img
                      src={`https://aigency.dev/api/images/${data.image}`}
                      width={148}
                      height={70}
                      alt="Brand Image"
                    />
                  </a>
                </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Brands;
